import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, } from "@inter-ikea-core/core";
export class DisableFrameInteractionSystem extends SystemBase {
    constructor() {
        super(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
        this.doingChangesOnComponent = [];
        this.id = "DisableFrameInteractionSystem";
        this.systemsAfterMe = null;
        this.systemsBeforeMe = null;
    }
    onAddComponent(_entity, _newComponent) {
        if (_entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID) ||
            _entity.hasComponent(ComponentIds.ASSEMBLY_STRUCTURE_COMPONENT_ID)) {
            _entity.removeComponent(ComponentIds.DRAGGABLE_COMPONENT_ID);
            _entity.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID);
            _entity.removeComponent(ComponentIds.OUTLINEABLE_COMPONENT_ID);
        }
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) { }
    onRemoveComponent(_entity, _oldComponent) { }
}
